import React from 'react'
import './Footer.css'

function Footer() {
  return (
    <div>
      <footer>
        <hr/>
        <div class="footer">
          <div class="footer1">
            ©Copyright Daniel A. Online Services 2022  |  Developed by   <a href="https://web.facebook.com/daniel.achilihu.9/">Achilihu Daniel Uchenna</a>                  
          </div>
        </div>
      </footer>

    </div>
  )
}

export default Footer